
<template>
  <router-btn :text="$t('servicesystem.common_objects.commonterms.cancel')"
              :icon="'mdi-close'"
              :color="'error'"
              :disabled="false"
              :outlined="true"
              :textbtn="textbtn"
              :large="large"
              :small="small"
              @Press="action">
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "CancelNewJobBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  created() {},

  mounted() {},

  methods: {
    action() {
      this.$router.push({ name: "JobList", params: { filter: this.$route.params.filter || "my" } });
    },
  },

  computed: {},

  watch: {},
};
</script>

<style lang="scss" scoped>
</style>
